import { useQuery } from '@tanstack/react-query';

export function useTrainingMatrixFileGenerationProcessQuery({
  generationProcessId,
}) {
  return useQuery({
    enabled: !!generationProcessId,
    queryKey: [
      'trainingMatrix',
      'fileGenerationProcesses',
      generationProcessId,
    ],
    queryFn: async () => {
      const response = await axios.get(
        `/training_matrix/file_generation_processes/${generationProcessId}`,
      );
      return response.data;
    },
    refetchInterval: (data) =>
      !data || ['completed', 'failed'].includes(data.data?.attributes?.status) ?
        false
      : 1000,
    refetchIntervalInBackground: true,
    retry: false,
  });
}
